module.exports = __webpack_public_path__ + "static/media/crosscancel.a451ab25.svg";